export default __webpack_public_path__ + "static/step_02-5736e9bcdcdacac5cd287daa061bedb2.png";